// A task's urgency as a chip, plus the helper for reducing a set of tasks to the
// hottest one among them.
//
// 'normal' renders NOTHING. That is the whole design: if the default carried a
// marking, the eye would have three things to weigh instead of one, and the scan
// for what is burning would stop working. Only deliberate deviations show.
import he from '../i18n/he';

export const URGENCY_ORDER = ['urgent', 'normal', 'low'];

const RANK = { urgent: 2, normal: 1, low: 0 };

// The hottest urgency across a set of tasks, or null for an empty set. Used to mark
// a collapsed lead: the visible "next step" is the earliest DUE task, which is not
// necessarily the most urgent one, so a burning task must not be able to hide
// behind a collapsed card.
export const topUrgency = (tasks) => {
  if (!tasks || tasks.length === 0) return null;
  return tasks.reduce((top, t) => {
    const u = t.urgency || 'normal';
    return (RANK[u] ?? 1) > (RANK[top] ?? 1) ? u : top;
  }, 'low');
};

// Does this client still have OPEN work at the given urgency? Used by the filters on
// both boards. Completed tasks are excluded deliberately: a finished task that was
// once burning is not work outstanding, and matching on it would surface clients
// with nothing left to do. A null filter matches everything.
export const matchesUrgency = (tasks, urgency) => {
  if (!urgency) return true;
  return (tasks || []).some((t) => t.status !== 'done' && (t.urgency || 'normal') === urgency);
};

export default function UrgencyBadge({ value }) {
  if (!value || value === 'normal') return null;
  return (
    <span
      className={`urgency urgency-${value}`}
      title={value === 'low' ? he.taskUrgencyHint : undefined}
    >
      {he.taskUrgency[value]}
    </span>
  );
}
